import {updateStats} from '@api/test';
import {actions, store} from '@components/Test/Context';
import OptionContent from '@components/Test/Option/OptionContent';
import type {SelectReducerAction} from '@interfaces/Test';
import type {ReactElement} from 'react';
import {useContext, useState} from 'react';
import {localize} from '@services/i18n';

interface Props {
    id: number;
    questionType: string;
    value?: number;
    content: string;
    comment?: string;
    statsPercentage: number;
    showStats: boolean;
    hasStatsLoaded: boolean;
    isStatsLoading: boolean;
}

export default function PointsOption(props: Props): ReactElement<Props> {
    const {currentState, dispatch} = useContext(store);
    const [modifier, setModifier] = useState('grey');

    function onClick() {
        if (!currentState.isChecked) {
            setModifier('green');
            dispatch({
                type: actions.check,
                data: {score: Number(props.value), comment: props.comment ?? '', id: props.id},
            } as SelectReducerAction);
            updateStats(currentState.id, currentState.questionNum, props.id);
        }
    }

    return (
        <div className={`test-option test-option--${props.questionType}`} onClick={onClick}>
            <OptionContent type={props.questionType} modifier={modifier} {...props} />
            {currentState.isChecked && props.showStats ? (
                <div className={`test-option__result test-option--${modifier}`}>
                    {props.isStatsLoading ? <span className="loading-spinner" /> : null}
                    {props.hasStatsLoaded ? (
                        <>
                            <span>
                                {currentState.selectedOption === props.id
                                    ? localize('Test_sameAnswers')
                                    : localize('Test_differentAnswers')}
                            </span>
                            <span>{props.statsPercentage}%</span>
                        </>
                    ) : null}
                </div>
            ) : null}
        </div>
    );
}
